module.exports = __webpack_public_path__ + "img/background-honey.e90e95a0.png";